import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const sendForgotPasswordLinkCacheKey = 'sendForgotPasswordLink';
export const sendForgotPasswordLinkDocument = /* GraphQL */ `
    mutation SendForgotPasswordLink($email: String!) {
        sendForgotPasswordLink(email: $email) {
            success
        }
    }
`;
export const sendForgotPasswordLinkMutation = graphql(sendForgotPasswordLinkDocument);
